import { DISMISSED_STORAGE_KEY } from '../../common/constants';

/**
 * Whether the modal has already been shown/dismissed in this browser. Reads are
 * defensive: storage may be unavailable (incognito, disabled cookies) in which
 * case we treat the modal as not-yet-dismissed.
 */
export function hasBeenDismissed(): boolean {
	try {
		return window.localStorage.getItem(DISMISSED_STORAGE_KEY) === 'true';
	} catch {
		return false;
	}
}

/** Persist that the modal has been shown so it is not shown again. */
export function markDismissed(): void {
	try {
		window.localStorage.setItem(DISMISSED_STORAGE_KEY, 'true');
	} catch {
		/* Storage unavailable — silently no-op. */
	}
}
